import { Button } from "@octopusdeploy/design-system-components";
import type { TaskResource, TaskState } from "@octopusdeploy/octopus-server-client";
import TaskStatusIcon from "~/areas/projects/components/TaskStatusIcon/index";
interface TaskQueueFilterProps {
    tasks: TaskResource[];
    isSelected: boolean;
    stateToFilter: TaskState | Interruption;
    selectState(state: TaskState | Interruption | null): void;
}
export enum Interruption {
    ManualIntervention = "Awaiting Manual Intervention"
}
export type TaskQueueFilterState = TaskState | Interruption | null;
export function filterStatePredicate(filterState: TaskState | Interruption | null): (t: TaskResource) => boolean {
    if (!filterState) {
        return (_) => true;
    }
    if (filterState === Interruption.ManualIntervention) {
        return (t) => t.HasPendingInterruptions;
    }
    return (t) => !t.HasPendingInterruptions && t.State === filterState;
}
export default (props: TaskQueueFilterProps) => {
    const { tasks, isSelected, stateToFilter, selectState } = props;
    const filteredTasks = tasks.filter(filterStatePredicate(stateToFilter));
    const count = filteredTasks.length;
    if (count === 0) {
        return null;
    }
    const sampleTask = filteredTasks[0];
    const taskIcon = <TaskStatusIcon size={20} item={sampleTask} iconOnly={true}/>;
    const toggleState = () => selectState(isSelected ? null : stateToFilter);
    return <Button onClick={toggleState} label={`${count} ${stateToFilter}`} importance={isSelected ? "loud" : "quiet"} icon={taskIcon}/>;
};
